import styled from 'styled-components';
import { theme } from '../../global';

export const CaseLinksContainer = styled.div`
  display: flex;
  gap: ${theme.spacings.s4};
  align-items: center;
  flex-wrap: wrap;
`;

export const Item = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
`;

export const LinkItem = styled.span`
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: 14px;
  line-height: 17.07px;
  text-decoration: underline;
  text-decoration-style: solid;
  // cursor: pointer;
  // white-space: nowrap;
  color: ${theme.colors.blue};
`;

export const Description = styled.span`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 14px;
  line-height: 17.07px;
  color: ${theme.colors.secondaryText};
  align-self: start;
`;
